// @ts-nocheck
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import getAutocompleteModel from "@insite/client-framework/Store/CommonHandlers/GetAutocompleteModel";
import { OrderStateContext } from "@insite/client-framework/Store/Data/Orders/OrdersSelectors";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import GridItem from "@insite/mobius/GridItem";
import Icon, { IconProps } from "@insite/mobius/Icon";
import Search from "@insite/mobius/Icons/Search";
import X from "@insite/mobius/Icons/X";
import TextField, { TextFieldProps } from "@insite/mobius/TextField";
import { GridItemProps } from "@store/MobiusOverrides/GridItem/GridItem";
import setOrderDetailsParameter from "@store/Framework/Store/Pages/OrderDetails/Handlers/SetOrderDetailsParameter";
import debounce from "lodash/debounce";
import React, { ChangeEvent, FC, useCallback, useState } from "react";
import { useContext } from "react";
import { connect, ResolveThunks } from "react-redux";
import { css } from "styled-components";

const mapStateToProps = (state: ApplicationState) => {
    return {
        orderDetailsParameter: state.store.pages.orderDetails.orderDetailsParameter,
    };
};

const mapDispatchToProps = {
    setOrderDetailsParameter,
    getAutocompleteModel,
};

export interface OrderHistorySearchFieldProductErpNumber2Styles {
    wrapper?: GridItemProps;
    clearIcon?: IconProps;
    search?: TextFieldProps;
}

export const orderHistorySearchFieldProductErpNumber2Styles: OrderHistorySearchFieldProductErpNumber2Styles = {
    wrapper: {
        width: 12,
        css: css`
            padding-top: 2rem;
            position: relative;

            @media print {
                display: none !important;
            }
        `,
    },
    clearIcon: {
        css: css`
            position: absolute;
            right: 45px;
            top: 74px;
            cursor: pointer;
        `,
        size: 24,
    },
    search: {
        iconProps: { src: Search },
    },
};
const styles = orderHistorySearchFieldProductErpNumber2Styles;

type Props = WidgetProps & ReturnType<typeof mapStateToProps> & ResolveThunks<typeof mapDispatchToProps>;

const OrderDetailsProductSearch: FC<Props> = ({ orderDetailsParameter: baseValue = "", setOrderDetailsParameter }) => {
    const { isLoading } = useContext(OrderStateContext);
    const [value, setValue] = useState(baseValue);

    const debouncedSearch = useCallback(
        debounce((query: string) => setOrderDetailsParameter({ orderDetailsParameter: query }), 300),
        [setOrderDetailsParameter],
    );

    const onInputChanged = (event: ChangeEvent<HTMLInputElement>) => {
        const newValue = event.currentTarget.value;
        setValue(newValue);
        debouncedSearch(newValue);
    };

    const clearButtonHandler = () => {
        setOrderDetailsParameter({ orderDetailsParameter: "" });
        setValue("");
    };

    if (isLoading) {
        return <></>;
    }

    return (
        <GridItem {...styles.wrapper}>
            <TextField
                {...styles.search}
                placeholder={translate("Search products in order")}
                value={value}
                onChange={onInputChanged}
                data-test-selector="wishListSearch"
                label={translate("Search within order")}
            />
            <Icon {...styles.clearIcon} src={X} onClick={clearButtonHandler} />
        </GridItem>
    );
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps, mapDispatchToProps)(OrderDetailsProductSearch),
    definition: {
        group: "Order Details",
        displayName: "Order Details Product Search",
        allowedContexts: ["OrderDetailsPage"],
    },
};

export default widgetModule;
